/**
 * AxWizard widget
 */
(function($) {
  $.widget('ui.axWizard', {
    options: {
      data: {},
      steps: []
    },

    /**
     * Constructor
     * @private
     */
    _create: function() {
      var self = this;

      self.$container = self.element;
    },

    /**
     * [_init description]
     * @private
     */
    _init: function() {
      var self = this;

      self._createNav();
      self.reset();
    },

    /**
     * [_createNav description]
     * @private
     */
    _createNav: function() {
      var self = this;

      if (!self.$container.is('.axwizard')) {
        var $tabs = self.$container.find('> ul');

        self.$container.addClass('axwizard');
        $tabs.addClass('nav-tabs');
        $tabs.find('> li').css({
          'width': Math.floor(self.$container.width() / $tabs.find('> li').length)
        }).each(function(i) {
          var $item = $(this);
          var $rtab = $('<span class="round-tab"><span class="value">'+(i+1)+'</span></span>');
          var $caption = $('<span class="caption">'+$item.text()+'</span>');
          var count = Math.floor(($item.outerWidth() / 2) / 11);

          $item.find('a').html($rtab).on('click', function(e) {
            e.preventDefault();
          });

          if (!$item.is('li:last-child')) {
            var $line = $('<div class="connecting-line"></div>');
            for (var i = 0; i < count; i++) {
              $line.append('<i class="fa fa-circle" aria-hidden="true"></i>');
            }
            $item.append($line);
          }

          $item.append($caption);
        });

        $tabs.find('> li > a').attr('data-toggle', 'tab');
        $tabs.find('> li:eq(0)').addClass('active');
        $tabs.find('> li:gt(0)').addClass('disabled');
      }
    },

    /**
     * [_goto description]
     * @param  {[type]} step [description]
     * @private
     */
    _goto: function(step) {
      var self = this;

      if (step >= 0 && step < self.options.steps.length) {
        var $tab = self.$container.find('.nav-tabs li:eq('+step+')');
        var $content = self.$container.find('[id=\''+$tab.find('a').attr('href')+'\']');

        self.$container.find('.nav-tabs li.active').removeClass('active');
        self.$container.find('.tab-content.active').removeClass('active');

        $tab.addClass('active');
        $content.addClass('active');
        self.options.steps[step].open(self);
      }
    },

    _clearStep: function() {
      var self = this;

      self.$container.find('.nav-tabs li:eq('+self.current_step+')').removeClass('done');
    },

    /**
     * [nextStep description]
     */
    nextStep: function() {
      var self = this;

      if (self.current_step < self.options.steps.length - 1) {
        self._clearStep();
        self.$container.find('.nav-tabs li:eq('+self.current_step+')').addClass('done');
        self.current_step++;
        self._goto(self.current_step);
      }
    },

    /**
     * [prevStep description]
     */
    prevStep: function() {
      var self = this;

      if (self.current_step > 0) {
        self.current_step--;
        self._goto(self.current_step);
      }
    },

    /**
     * [refresh description]
     * @return {[type]} [description]
     */
    refresh: function() {
      var self = this;

      self._goto(self.current_step);
    },

    /**
     * [reset description]
     */
    reset: function() {
      var self = this;

      self.tmp = {};
      self.current_step = 0;
      self.$container.find('.nav-tabs li.done').removeClass('done');
      self._goto(self.current_step);
    }
  });

  $.extend($.ui.axWizard, {
    version: "1.0.0"
  });
})(jQuery);
